import { NgClass } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	input,
	ViewEncapsulation,
} from '@angular/core';

import { AngularSvgIconModule } from 'angular-svg-icon';

import type { IconGridItem } from './icon-grid.interface';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [AngularSvgIconModule, NgClass],
	selector: 'vp-icon-grid',
	templateUrl: './icon-grid.html',
})
export class IconGridComponent {
	items = input<IconGridItem[]>([]);
}
